import "../button_vars.css";
import $cZmNf$button_vars_cssmjs from "../button_vars_css.mjs";
import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {ClearButton as $ab14010a528467be$export$13ec83e50bf04290} from "../button/ClearButton.mjs";
import "./combobox.css";
import $cZmNf$combobox_cssmjs from "./combobox_css.mjs";
import {Field as $adcd096854d27620$export$a455218a85c89869} from "../label/Field.mjs";
import $cZmNf$intlStringsmjs from "./intlStrings.mjs";
import "../fieldlabel_vars.css";
import $cZmNf$fieldlabel_vars_cssmjs from "../fieldlabel_vars_css.mjs";
import {ListBoxBase as $ee13b4eccaed924f$export$1afdcf349979fb7e, useListBoxLayout as $ee13b4eccaed924f$export$25768ea656ae32a7} from "../listbox/ListBoxBase.mjs";
import {ProgressCircle as $1cfe37e7feefa23d$export$c79b9d6b4cc92af7} from "../progress/ProgressCircle.mjs";
import "../search_vars.css";
import $cZmNf$search_vars_cssmjs from "../search_vars_css.mjs";
import "../inputgroup_vars.css";
import $cZmNf$inputgroup_vars_cssmjs from "../inputgroup_vars_css.mjs";
import {TextFieldBase as $b312f2102feb9487$export$d22444a338b6e3c2} from "../textfield/TextFieldBase.mjs";
import "../textfield_vars.css";
import $cZmNf$textfield_vars_cssmjs from "../textfield_vars_css.mjs";
import {Tray as $9fca089dca5508dc$export$4589ed81930b555c} from "../overlays/Tray.mjs";
import {unwrapDOMRef as $3c2c983d5210446c$export$c7e28c72a4823176, useFocusableRef as $3c2c983d5210446c$export$96a734597687c040} from "../utils/useDOMRef.mjs";
import {useProviderProps as $71dfb0e0358a12de$export$521c373ccc32c300} from "../provider/Provider.mjs";
import $cZmNf$spectrumiconsuiAlertMedium from "@spectrum-icons/ui/AlertMedium";
import {useButton as $cZmNf$useButton} from "react-aria/useButton";
import $cZmNf$spectrumiconsuiCheckmarkMedium from "@spectrum-icons/ui/CheckmarkMedium";
import $cZmNf$spectrumiconsuiChevronDownMedium from "@spectrum-icons/ui/ChevronDownMedium";
import {useComboBoxState as $cZmNf$useComboBoxState} from "react-stately/useComboBoxState";
import {DismissButton as $cZmNf$DismissButton} from "react-aria/Overlay";
import {FocusRing as $cZmNf$FocusRing} from "react-aria/FocusRing";
import {focusSafely as $cZmNf$focusSafely} from "react-aria/private/interactions/focusSafely";
import {FocusScope as $cZmNf$FocusScope} from "react-aria/FocusScope";
import {getActiveElement as $cZmNf$getActiveElement} from "react-aria/private/utils/shadowdom/DOMFunctions";
import {mergeProps as $cZmNf$mergeProps} from "react-aria/mergeProps";
import $cZmNf$react, {useRef as $cZmNf$useRef, useState as $cZmNf$useState, useCallback as $cZmNf$useCallback, useEffect as $cZmNf$useEffect} from "react";
import {setInteractionModality as $cZmNf$setInteractionModality} from "react-aria/private/interactions/useFocusVisible";
import {useComboBox as $cZmNf$useComboBox} from "react-aria/useComboBox";
import {useDialog as $cZmNf$useDialog} from "react-aria/useDialog";
import {useField as $cZmNf$useField} from "react-aria/useField";
import {useFilter as $cZmNf$useFilter} from "react-aria/useFilter";
import {useFormReset as $cZmNf$useFormReset} from "react-aria/private/utils/useFormReset";
import {useFormValidation as $cZmNf$useFormValidation} from "react-aria/private/form/useFormValidation";
import {useHover as $cZmNf$useHover} from "react-aria/useHover";
import {useId as $cZmNf$useId} from "react-aria/useId";
import {useLocalizedStringFormatter as $cZmNf$useLocalizedStringFormatter} from "react-aria/useLocalizedStringFormatter";
import {useObjectRef as $cZmNf$useObjectRef} from "react-aria/useObjectRef";
import {useOverlayTrigger as $cZmNf$useOverlayTrigger} from "react-aria/useOverlayTrigger";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 







































const $5815f9078a56ef80$export$7637df911c069b4d = /*#__PURE__*/ (0, $cZmNf$react).forwardRef(function MobileComboBox(props, ref) {
    props = (0, $71dfb0e0358a12de$export$521c373ccc32c300)(props);
    let { isQuiet: isQuiet, isDisabled: isDisabled, isReadOnly: isReadOnly, isRequired: isRequired, validationBehavior: validationBehavior, name: name, formValue: formValue = 'text', allowsCustomValue: allowsCustomValue } = props;
    if (allowsCustomValue) formValue = 'text';
    let { contains: contains } = (0, $cZmNf$useFilter)({
        sensitivity: 'base'
    });
    let state = (0, $cZmNf$useComboBoxState)({
        ...props,
        defaultFilter: contains,
        allowsEmptyCollection: true,
        // Needs to be false here otherwise we double up on commitSelection/commitCustomValue calls when
        // user taps on underlay (i.e. initial tap will call setFocused(false) -> commitSelection/commitCustomValue via onBlur,
        // then the closing of the tray will call setFocused(false) again due to cleanup effect)
        shouldCloseOnBlur: false
    });
    let buttonRef = (0, $cZmNf$useRef)(null);
    let domRef = (0, $3c2c983d5210446c$export$96a734597687c040)(ref, buttonRef);
    let { triggerProps: triggerProps, overlayProps: overlayProps } = (0, $cZmNf$useOverlayTrigger)({
        type: 'listbox'
    }, state, buttonRef);
    let inputRef = (0, $cZmNf$useRef)(null);
    (0, $cZmNf$useFormValidation)({
        ...props,
        focus: ()=>buttonRef.current?.focus()
    }, state, inputRef);
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let validationState = props.validationState || (isInvalid ? 'invalid' : undefined);
    let errorMessage = props.errorMessage ?? validationErrors.join(' ');
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $cZmNf$useField)({
        ...props,
        labelElementType: 'span',
        isInvalid: isInvalid,
        errorMessage: errorMessage
    });
    // Focus the button and show focus ring when clicking on the label
    labelProps.onClick = ()=>{
        if (!props.isDisabled) {
            buttonRef.current?.focus();
            (0, $cZmNf$setInteractionModality)('keyboard');
        }
    };
    let inputProps = {
        type: 'hidden',
        name: name,
        value: formValue === 'text' ? state.inputValue : String(state.selectedKey)
    };
    if (validationBehavior === 'native') {
        // Use a hidden <input type="text"> rather than <input type="hidden">
        // so that an empty value blocks HTML form submission when the field is required.
        inputProps.type = 'text';
        inputProps.hidden = true;
        inputProps.required = isRequired;
        // Ignore react warning.
        inputProps.onChange = ()=>{};
    }
    (0, $cZmNf$useFormReset)(inputRef, formValue === 'text' ? state.defaultInputValue : state.defaultSelectedKey, formValue === 'text' ? state.setInputValue : state.setSelectedKey);
    return /*#__PURE__*/ (0, $cZmNf$react).createElement((0, $cZmNf$react).Fragment, null, /*#__PURE__*/ (0, $cZmNf$react).createElement((0, $adcd096854d27620$export$a455218a85c89869), {
        ...props,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        validationState: validationState,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        elementType: "span",
        ref: domRef,
        includeNecessityIndicatorInAccessibilityName: true
    }, /*#__PURE__*/ (0, $cZmNf$react).createElement($5815f9078a56ef80$export$adfa0abcd5972f7e, {
        ...(0, $cZmNf$mergeProps)(triggerProps, fieldProps, {
            autoFocus: props.autoFocus
        }),
        ref: buttonRef,
        isQuiet: isQuiet,
        isDisabled: isDisabled,
        isPlaceholder: !state.inputValue,
        validationState: validationState,
        onPress: ()=>!isReadOnly && state.open(null, 'manual')
    }, state.inputValue || props.placeholder || '')), /*#__PURE__*/ (0, $cZmNf$react).createElement("input", {
        ...inputProps,
        ref: inputRef
    }), /*#__PURE__*/ (0, $cZmNf$react).createElement((0, $9fca089dca5508dc$export$4589ed81930b555c), {
        state: state,
        isFixedHeight: true,
        ...overlayProps
    }, /*#__PURE__*/ (0, $cZmNf$react).createElement($5815f9078a56ef80$var$ComboBoxTray, {
        ...props,
        onClose: state.close,
        overlayProps: overlayProps,
        state: state
    })));
});
const $5815f9078a56ef80$export$adfa0abcd5972f7e = /*#__PURE__*/ (0, $cZmNf$react).forwardRef(function ComboBoxButton(props, ref) {
    let { isQuiet: isQuiet, isDisabled: isDisabled, isPlaceholder: isPlaceholder, validationState: validationState, children: children, style: style, className: className } = props;
    let stringFormatter = (0, $cZmNf$useLocalizedStringFormatter)((0, ($parcel$interopDefault($cZmNf$intlStringsmjs))), '@react-spectrum/combobox');
    let valueId = (0, $cZmNf$useId)();
    let invalidId = (0, $cZmNf$useId)();
    let validId = (0, $cZmNf$useId)();
    let validationIcon = validationState === 'invalid' ? /*#__PURE__*/ (0, $cZmNf$react).createElement((0, $cZmNf$spectrumiconsuiAlertMedium), {
        id: invalidId,
        "aria-label": stringFormatter.format('invalid')
    }) : /*#__PURE__*/ (0, $cZmNf$react).createElement((0, $cZmNf$spectrumiconsuiCheckmarkMedium), {
        id: validId,
        "aria-label": stringFormatter.format('valid')
    });
    let validation = /*#__PURE__*/ (0, $cZmNf$react).cloneElement(validationIcon, {
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$textfield_vars_cssmjs))), 'spectrum-Textfield-validationIcon', (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$inputgroup_vars_cssmjs))), 'spectrum-InputGroup-input-validationIcon'))
    });
    let objRef = (0, $cZmNf$useObjectRef)(ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $cZmNf$useHover)({});
    let { buttonProps: buttonProps, isPressed: isPressed } = (0, $cZmNf$useButton)({
        ...props,
        'aria-labelledby': [
            props['aria-labelledby'],
            props['aria-label'] && !props['aria-labelledby'] ? props.id : null,
            valueId,
            validationState === 'invalid' ? invalidId : null,
            validationState === 'valid' ? validId : null
        ].filter(Boolean).join(' '),
        elementType: 'div'
    }, objRef);
    return /*#__PURE__*/ (0, $cZmNf$react).createElement((0, $cZmNf$FocusRing), {
        focusClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$inputgroup_vars_cssmjs))), 'is-focused'),
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$inputgroup_vars_cssmjs))), 'focus-ring')
    }, /*#__PURE__*/ (0, $cZmNf$react).createElement("div", {
        ...(0, $cZmNf$mergeProps)(hoverProps, buttonProps),
        "aria-haspopup": "dialog",
        ref: objRef,
        style: {
            ...style,
            outline: 'none'
        },
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$inputgroup_vars_cssmjs))), 'spectrum-InputGroup', {
            'spectrum-InputGroup--quiet': isQuiet,
            'is-disabled': isDisabled,
            'spectrum-InputGroup--invalid': validationState === 'invalid' && !isDisabled,
            'is-hovered': isHovered
        }, (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$combobox_cssmjs))), 'mobile-combobox'), className)
    }, /*#__PURE__*/ (0, $cZmNf$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$textfield_vars_cssmjs))), 'spectrum-Textfield', {
            'spectrum-Textfield--invalid': validationState === 'invalid' && !isDisabled,
            'spectrum-Textfield--valid': validationState === 'valid' && !isDisabled,
            'spectrum-Textfield--quiet': isQuiet
        }, (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$inputgroup_vars_cssmjs))), 'spectrum-InputGroup-field'))
    }, /*#__PURE__*/ (0, $cZmNf$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$textfield_vars_cssmjs))), 'spectrum-Textfield-input', {
            'is-hovered': isHovered,
            'is-placeholder': isPlaceholder,
            'is-disabled': isDisabled
        }, (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$inputgroup_vars_cssmjs))), 'spectrum-InputGroup-input', (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$fieldlabel_vars_cssmjs))), 'spectrum-Field-field')), (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$combobox_cssmjs))), 'mobile-input'))
    }, /*#__PURE__*/ (0, $cZmNf$react).createElement("span", {
        id: valueId,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$combobox_cssmjs))), 'mobile-value')
    }, children)), validationState && !isDisabled ? validation : null), /*#__PURE__*/ (0, $cZmNf$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$button_vars_cssmjs))), 'spectrum-FieldButton', {
            'spectrum-FieldButton--quiet': isQuiet,
            'is-active': isPressed,
            'is-disabled': isDisabled,
            'spectrum-FieldButton--invalid': validationState === 'invalid' && !isDisabled,
            'is-hovered': isHovered
        }, (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$inputgroup_vars_cssmjs))), 'spectrum-FieldButton'))
    }, /*#__PURE__*/ (0, $cZmNf$react).createElement((0, $cZmNf$spectrumiconsuiChevronDownMedium), {
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$inputgroup_vars_cssmjs))), 'spectrum-Dropdown-chevron')
    }))));
});
function $5815f9078a56ef80$var$ComboBoxTray(props) {
    let { state: // completionMode = 'suggest',
    state, isDisabled: isDisabled, validationState: validationState, label: label, overlayProps: overlayProps, loadingState: loadingState, onLoadMore: onLoadMore, onClose: onClose } = props;
    let timeout = (0, $cZmNf$useRef)(null);
    let [showLoading, setShowLoading] = (0, $cZmNf$useState)(false);
    let inputRef = (0, $cZmNf$useRef)(null);
    let buttonRef = (0, $cZmNf$useRef)(null);
    let popoverRef = (0, $cZmNf$useRef)(null);
    let listBoxRef = (0, $cZmNf$useRef)(null);
    let isLoading = loadingState === 'loading' || loadingState === 'loadingMore';
    let layout = (0, $ee13b4eccaed924f$export$25768ea656ae32a7)();
    let stringFormatter = (0, $cZmNf$useLocalizedStringFormatter)((0, ($parcel$interopDefault($cZmNf$intlStringsmjs))), '@react-spectrum/combobox');
    let { inputProps: inputProps, listBoxProps: listBoxProps, labelProps: labelProps } = (0, $cZmNf$useComboBox)({
        ...props,
        // completionMode,
        layoutDelegate: layout,
        buttonRef: (0, $3c2c983d5210446c$export$c7e28c72a4823176)(buttonRef),
        popoverRef: popoverRef,
        listBoxRef: listBoxRef,
        inputRef: inputRef,
        // Handled outside the tray.
        name: undefined
    }, state);
    (0, $cZmNf$react).useEffect(()=>{
        if (inputRef.current) (0, $cZmNf$focusSafely)(inputRef.current);
    }, []);
    (0, $cZmNf$react).useEffect(()=>{
        // When the tray closes, set state.isFocused (i.e. the tray input's focus tracker) to false.
        // This is to prevent state.isFocused from being set to true when the tray closes via tapping on the underlay
        // (FocusScope attempts to restore focus to the tray input when tapping outside the tray due to "contain")
        // Have to do this manually since React doesn't call onBlur when a component is unmounted: https://github.com/facebook/react/issues/12363
        if (!state.isOpen && state.isFocused) state.setFocused(false);
    });
    let { dialogProps: dialogProps } = (0, $cZmNf$useDialog)({
        'aria-labelledby': (0, $cZmNf$useId)(labelProps.id)
    }, popoverRef);
    // Override the role of the input to "searchbox" instead of "combobox".
    // Since the listbox is always visible, the combobox role doesn't really give us anything.
    // VoiceOver on iOS reads "double tap to collapse" when focused on the input rather than
    // "double tap to edit text", as with a textbox or searchbox. We'd like double tapping to
    // open the virtual keyboard rather than closing the tray.
    // Unlike "combobox", "aria-expanded" is not a valid attribute on "searchbox".
    inputProps.role = 'searchbox';
    inputProps['aria-haspopup'] = 'listbox';
    delete inputProps['aria-expanded'];
    delete inputProps.onTouchEnd;
    let clearButton = /*#__PURE__*/ (0, $cZmNf$react).createElement((0, $ab14010a528467be$export$13ec83e50bf04290), {
        preventFocus: true,
        "aria-label": stringFormatter.format('clear'),
        excludeFromTabOrder: true,
        onPress: ()=>{
            state.setInputValue('');
            inputRef.current?.focus();
        },
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$search_vars_cssmjs))), 'spectrum-ClearButton'),
        isDisabled: isDisabled
    });
    let loadingCircle = /*#__PURE__*/ (0, $cZmNf$react).createElement((0, $1cfe37e7feefa23d$export$c79b9d6b4cc92af7), {
        "aria-label": stringFormatter.format('loading'),
        size: "S",
        isIndeterminate: true,
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$search_vars_cssmjs))), 'spectrum-Search-circleLoader', (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$textfield_vars_cssmjs))), 'spectrum-Textfield-circleLoader'))
    });
    // Close the software keyboard on scroll to give the user a bigger area to scroll.
    // But only do this if scrolling with touch, otherwise it can cause issues with touch
    // screen readers.
    let isTouchDown = (0, $cZmNf$useRef)(false);
    let onTouchStart = ()=>{
        isTouchDown.current = true;
    };
    let onTouchEnd = ()=>{
        isTouchDown.current = false;
    };
    let onScroll = (0, $cZmNf$useCallback)(()=>{
        if (!inputRef.current || (0, $cZmNf$getActiveElement)() !== inputRef.current || !isTouchDown.current) return;
        popoverRef.current?.focus();
    }, [
        inputRef,
        popoverRef,
        isTouchDown
    ]);
    let inputValue = inputProps.value;
    let lastInputValue = (0, $cZmNf$useRef)(inputValue);
    (0, $cZmNf$useEffect)(()=>{
        if (loadingState === 'filtering' && !showLoading) {
            if (timeout.current === null) timeout.current = setTimeout(()=>{
                setShowLoading(true);
            }, 500);
            // If user is typing, clear the timer and restart since it is a new request
            if (inputValue !== lastInputValue.current) {
                clearTimeout(timeout.current);
                timeout.current = setTimeout(()=>{
                    setShowLoading(true);
                }, 500);
            }
        } else if (loadingState !== 'filtering') {
            // If loading is no longer happening, clear any timers and hide the loading circle
            setShowLoading(false);
            if (timeout.current) clearTimeout(timeout.current);
            timeout.current = null;
        }
        lastInputValue.current = inputValue;
    }, [
        loadingState,
        inputValue,
        showLoading
    ]);
    let onKeyDown = (e)=>{
        // Close virtual keyboard if user hits Enter w/o any focused options
        if (e.key === 'Enter' && state.selectionManager.focusedKey == null) popoverRef.current?.focus();
        else inputProps.onKeyDown?.(e);
    };
    return /*#__PURE__*/ (0, $cZmNf$react).createElement((0, $cZmNf$FocusScope), {
        restoreFocus: true,
        contain: true
    }, /*#__PURE__*/ (0, $cZmNf$react).createElement("div", {
        ...(0, $cZmNf$mergeProps)(overlayProps, dialogProps),
        ref: popoverRef,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$combobox_cssmjs))), 'tray-dialog')
    }, /*#__PURE__*/ (0, $cZmNf$react).createElement((0, $cZmNf$DismissButton), {
        onDismiss: onClose
    }), /*#__PURE__*/ (0, $cZmNf$react).createElement((0, $b312f2102feb9487$export$d22444a338b6e3c2), {
        label: label,
        labelProps: labelProps,
        inputProps: {
            ...inputProps,
            onKeyDown: onKeyDown
        },
        inputRef: inputRef,
        isDisabled: isDisabled,
        isLoading: showLoading && loadingState === 'filtering',
        loadingIndicator: loadingState != null ? loadingCircle : undefined,
        validationState: validationState,
        labelAlign: "start",
        labelPosition: "top",
        wrapperChildren: (state.inputValue !== '' || loadingState === 'filtering' || validationState != null) && !props.isReadOnly ? clearButton : undefined,
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$search_vars_cssmjs))), 'spectrum-Search', 'spectrum-Textfield', 'spectrum-Search--loadable', {
            'spectrum-Search--invalid': validationState === 'invalid' && !isDisabled,
            'spectrum-Search--valid': validationState === 'valid' && !isDisabled
        }, (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$combobox_cssmjs))), 'tray-textfield', {
            'has-label': !!props.label
        })),
        inputClassName: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$combobox_cssmjs))), 'tray-textfield-input', (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$search_vars_cssmjs))), 'spectrum-Search-input')),
        validationIconClassName: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$search_vars_cssmjs))), 'spectrum-Search-validationIcon')
    }), /*#__PURE__*/ (0, $cZmNf$react).createElement((0, $ee13b4eccaed924f$export$1afdcf349979fb7e), {
        ...listBoxProps,
        domProps: {
            onTouchStart: onTouchStart,
            onTouchEnd: onTouchEnd
        },
        disallowEmptySelection: true,
        shouldSelectOnPressUp: true,
        focusOnPointerEnter: true,
        layout: layout,
        state: state,
        shouldUseVirtualFocus: true,
        renderEmptyState: ()=>loadingState !== 'loading' && /*#__PURE__*/ (0, $cZmNf$react).createElement("span", {
                className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$combobox_cssmjs))), 'no-results')
            }, stringFormatter.format('noResults')),
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cZmNf$combobox_cssmjs))), 'tray-listbox'),
        ref: listBoxRef,
        onScroll: onScroll,
        onLoadMore: onLoadMore,
        isLoading: isLoading
    }), /*#__PURE__*/ (0, $cZmNf$react).createElement((0, $cZmNf$DismissButton), {
        onDismiss: onClose
    })));
}


export {$5815f9078a56ef80$export$7637df911c069b4d as MobileComboBox, $5815f9078a56ef80$export$adfa0abcd5972f7e as ComboBoxButton};
//# sourceMappingURL=MobileComboBox.mjs.map
